<div class="client-notes">
  <div class="heading-wrapper">
    <div class="d-flex heading-wrapper_title">
      <h4>{{ 'pages.client.notes.title' | translate }}</h4>
      <app-tooltip [marginBottom]="true" text="clientNotes" />
    </div>
    <button class="action-btn secondary" (click)="startAdd()" [disabled]="isEditing">
      <i class="bi bi-plus-circle" alt="add"></i>
      {{ 'pages.client.notes.addNew' | translate }}
    </button>
  </div>

  @if (!notes || (notes.length === 0 && !isAddingNote)) {
    <p class="no-notes">{{ 'pages.client.notes.noNotes' | translate }}</p>
  } @else {
    <div class="table_wrapper">
      <table class="table my-0">
        <colgroup>
          <col style="width: 40%" />
          <col style="width: 15%" />
          <col style="width: 25%" />
          <col style="width: 20%" />
        </colgroup>
        <thead>
          <tr>
            <td>
              <div class="d-flex align-items-center">
                <p>{{ 'pages.client.notes.table.text' | translate }}</p>
                <div class="tooltip-wrapper">
                  <app-tooltip [marginBottom]="false" text="clientNotesText" position="bottom-right" />
                </div>
              </div>
            </td>
            <td>
              <p>{{ 'pages.client.notes.table.registrationInfo' | translate }}</p>
            </td>
            <td>
              <div class="d-flex align-items-center">
                <p>{{ 'pages.client.notes.table.files' | translate }}</p>
                <div class="tooltip-wrapper">
                  <app-tooltip [marginBottom]="false" text="clientNotesFiles" position="bottom-right" />
                </div>
              </div>
            </td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          @if (isAddingNote) {
            <tr class="editing-row">
              <td>
                <div class="inline-form" [formGroup]="form">
                  <div class="textarea-wrapper">
                    <textarea
                      class="form-control lna"
                      [ngClass]="{ invalid: shouldRenderError('text') && text?.errors }"
                      rows="4"
                      maxlength="{{ maxDescriptionLength }}"
                      formControlName="text"
                      type="text"></textarea>
                    <p class="length" [ngClass]="{ invalid: text?.value?.length > maxDescriptionLength }">
                      {{ text?.value?.length || 0 }}/{{ maxDescriptionLength }}
                    </p>
                  </div>
                  @if (shouldRenderError('text') && text?.errors) {
                    @if (text?.errors?.['required']) {
                      <small class="error-message">{{ 'components.form.errorRequired' | translate }}</small>
                    } @else if (text?.errors?.['minlength']) {
                      <small class="error-message">
                        {{ 'components.form.minLength' | translate: { minLength: text?.errors?.['minlength']['requiredLength'] } }}
                      </small>
                    } @else if (text?.errors?.['maxlength']) {
                      <small class="error-message">
                        {{ 'components.form.maxLength' | translate: { maxLength: text?.errors?.['maxlength']['requiredLength'] } }}
                      </small>
                    }
                  }
                </div>
              </td>
              <td>
                <div class="registrationInfo">
                  <p>{{ formatDatetime(today) }}</p>
                  <p>{{ userFullName }}</p>
                </div>
              </td>
              <td>
                <app-file-upload
                  [isEditMode]="true"
                  [existingFiles]="[]"
                  [type]="clientNoteFileType"
                  [associatedEntityId]="newNoteId || ''"
                  [isSubmitting]="isSubmittingNoteFiles"
                  [showDescription]="false"
                  (uploading)="handleFileRequests($event)" />
              </td>
              <td>
                <div class="action-btn_wrapper">
                  <button class="primary" (click)="saveNote()" [disabled]="isSaving" type="button">
                    {{ 'pages.client.notes.table.submit' | translate }}
                  </button>
                  <button class="secondary" (click)="cancelEdit()" [disabled]="isSaving" type="button">
                    {{ 'pages.client.notes.table.cancel' | translate }}
                  </button>
                </div>
              </td>
            </tr>
          }
          @for (note of visibleNotes; track note.id) {
            @if (editingNoteId === note.id) {
              <tr class="editing-row">
                <td>
                  <div class="inline-form" [formGroup]="form">
                    <div class="textarea-wrapper">
                      <textarea
                        class="form-control lna"
                        [ngClass]="{ invalid: shouldRenderError('text') && text?.errors }"
                        rows="4"
                        maxlength="{{ maxDescriptionLength }}"
                        formControlName="text"
                        type="text"></textarea>
                      <p class="length" [ngClass]="{ invalid: text?.value?.length > maxDescriptionLength }">
                        {{ text?.value?.length || 0 }}/{{ maxDescriptionLength }}
                      </p>
                    </div>
                    @if (shouldRenderError('text') && text?.errors) {
                      @if (text?.errors?.['required']) {
                        <small class="error-message">{{ 'components.form.errorRequired' | translate }}</small>
                      } @else if (text?.errors?.['minlength']) {
                        <small class="error-message">
                          {{ 'components.form.minLength' | translate: { minLength: text?.errors?.['minlength']['requiredLength'] } }}
                        </small>
                      } @else if (text?.errors?.['maxlength']) {
                        <small class="error-message">
                          {{ 'components.form.maxLength' | translate: { maxLength: text?.errors?.['maxlength']['requiredLength'] } }}
                        </small>
                      }
                    }
                  </div>
                </td>
                <td>
                  <div class="registrationInfo">
                    <p>{{ formatDatetime(note.createdOn || '') }}</p>
                    <p>{{ (note.user.firstName || '') + ' ' + (note.user.lastName || '') }}</p>
                  </div>
                </td>
                <td>
                  <app-file-upload
                    [isEditMode]="true"
                    [existingFiles]="note.clientNoteFiles"
                    [type]="clientNoteFileType"
                    [associatedEntityId]="note!.id!"
                    [isSubmitting]="isSubmittingNoteFiles"
                    [showDescription]="false"
                    (uploading)="handleFileRequests($event)" />
                </td>
                <td>
                  <div class="action-btn_wrapper">
                    <button class="primary" (click)="saveNote()" [disabled]="isSaving" type="button">
                      {{ 'pages.client.notes.table.submit' | translate }}
                    </button>
                    <button class="secondary" (click)="cancelEdit()" [disabled]="isSaving" type="button">
                      {{ 'pages.client.notes.table.cancel' | translate }}
                    </button>
                  </div>
                </td>
              </tr>
            } @else {
              <tr>
                <td>
                  <p>{{ note.text }}</p>
                </td>
                <td>
                  <div class="registrationInfo">
                    <p>{{ formatDatetime(note.createdOn || '') }}</p>
                    <p>{{ (note.user.firstName || '') + ' ' + (note.user.lastName || '') }}</p>
                  </div>
                </td>
                <td>
                  <app-file-upload
                    [isEditMode]="false"
                    [existingFiles]="note.clientNoteFiles"
                    [type]="clientNoteFileType"
                    [associatedEntityId]="note!.id!"
                    [isSubmitting]="false"
                    (uploading)="handleFileRequests($event)" />
                </td>
                <td>
                  @if (note.userId === userId) {
                    <div class="action-btn_wrapper">
                      <button class="note-action-btn" (click)="confirmDelete(note.id!)" [disabled]="isEditing">
                        <i class="bi bi-trash"></i>
                        {{ 'components.updateClientNoteItem.remove' | translate }}
                      </button>
                      <button class="note-action-btn" (click)="startEdit(note)" [disabled]="isEditing">
                        <i class="bi bi-pencil"></i>
                        {{ 'pages.client.notes.table.edit' | translate }}
                      </button>
                    </div>
                  }
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  }
</div>

@if (notes?.length! > 5) {
  <div class="pagination-wrapper">
    @if (notes?.length! > pageSize) {
      <ngb-pagination
        [(page)]="page"
        [pageSize]="pageSize"
        [collectionSize]="notes?.length!"
        [maxSize]="5"
        [ellipses]="true" />
    }
  </div>
}

<app-confirm-modal
  [isOpen]="isOpenConfirmDeleteNote"
  (confirm)="deleteNote()"
  (cancel)="onDeleteModalClose()"
  title="deleteClientNote" />
